import React from "react";
import styled from "styled-components";
import {
  JAGROOK_MESSAGE,
  RISK_DISCLOSURES,
  SEBI_AWARENESS_DISPLAY
} from "nxtconstants/sebiInvestorAwareness";

const SebiInvestorAwareness = () => {
  const {showJagrook, showRiskDisclosures} = SEBI_AWARENESS_DISPLAY;

  if (!showJagrook && !showRiskDisclosures) {
    return null;
  }

  return (
    <Box>
      {showJagrook ? (
        <>
          <Heading>{JAGROOK_MESSAGE.heading}</Heading>
          <Subtitle>{JAGROOK_MESSAGE.title}</Subtitle>
          <Points>
            {JAGROOK_MESSAGE.points.map((point) => (
              <Point key={point}>
                <Check aria-hidden="true">✓</Check>
                {point}
              </Point>
            ))}
          </Points>
        </>
      ) : null}
      {showRiskDisclosures ? (
        <Risk>
          <p>
            <b>{RISK_DISCLOSURES.title}</b>
          </p>
          {RISK_DISCLOSURES.points.map((point) => (
            <p key={point}>
              • {point}
            </p>
          ))}
          <p>
            <b>Source:</b>
            {" "}
            {RISK_DISCLOSURES.source}
          </p>
        </Risk>
      ) : null}
    </Box>
  );
};

const Box = styled.div`
  border: 1px solid #d97a7a;
  border-radius: 8px;
  padding: 16px 20px 8px;
  margin: 0 0 16px;
  background: rgba(255, 255, 255, 0.04);
`;

const Heading = styled.p`
  && {
    text-align: center;
    font-family: Avenir-Heavy, Avenir;
    font-size: 16px;
    color: #1c1c1c;
    margin: 0 0 8px;
  }
`;

const Subtitle = styled.p`
  && {
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    color: #1c1c1c;
    margin: 0 0 12px;
  }
`;

const Points = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px 22px;
  margin: 0 0 12px;

  @media screen and (max-width: 730px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

const Point = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #ccc;
  line-height: 1.4;
`;

const Check = styled.span`
  color: #e24c4c;
  font-weight: 700;
  font-size: 13px;
`;

const Risk = styled.div`
  margin-top: 8px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
`;

export default SebiInvestorAwareness;
